import { persistReducer } from 'redux-persist'
import { Reducer, Action } from 'redux'
import storage from './storage'

// import { CookieStorage } from 'redux-persist-cookie-storage'
// import Cookies from 'js-cookie'

const persistReducers = (reducers: Reducer<unknown, Action<any>>): any => {
  return persistReducer(
    {
      key: '@DirecaoConcursos',
      storage,
      whitelist: [
        'student',
        'acceptCookies',
        'auth',
        'showGuide',
        'showInformation',
        'theme',
        'toolsMenuInfo',
        'recentView',
        'studyPlan',
        'timer',
        'tour',
      ],
    },
    reducers
  )
}

export default persistReducers
